import styled from '@emotion/styled/macro';
import rem from '../../utils/rem/rem';
import { StyledProps } from './Checkbox.types';

export const Container = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const StyledCheckbox = styled.input<StyledProps>`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: 1px solid ${({ theme }) => theme.colors.gray900};
  border-radius: 2px;
  width: ${rem(20)};
  height: ${rem(20)};
  
  ${({ indeterminate, theme }) => indeterminate && `
  &:not(:checked) + svg {
    display: block;
    position: absolute;
    top: calc(50% - ${rem(10)});
    left: 4px;
    pointer-events: none;
    border: 1px solid ${theme.colors.gray900};
    background-color: ${theme.colors.white};
    border-radius: 2px;
    width: ${rem(20)};
    height: ${rem(20)};
    color: ${theme.colors.gray900};
  }
  &:checked + svg {
    display: block;
    position: absolute;
    top: calc(50% - ${rem(10)});
    left: 4px;
    pointer-events: none;
  }
  `}

  ${({ indeterminate }) => !indeterminate && `
  &:checked + svg {
    display: block;
    position: absolute;
    top: calc(50% - ${rem(10)});
    left: 4px;
    pointer-events: none;
  }

  &:not(:checked) + svg {
    display: none;
  }`}

  &:checked {
    background-color: ${({ theme }) => theme.colors.gray900};
  }

  &:disabled {
    border: 1px solid ${({ theme }) => theme.colors.gray400};
    background-color: ${({ theme }) => theme.colors.gray100};
    pointer-events: none;
  }

  &:focus {
    outline: 2px dashed ${({ theme }) => theme.colors.red};
    outline-offset: 2px;
  }
`;

export const Label = styled.label<{ bold?: boolean }>`
  padding-left: 8px;
  font-family: 'Open Sans';
  font-weight: ${({ bold }) => (bold ? 600 : 400)};
  font-size: ${rem(14)};
`;
